import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('bike-search-page-handler', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./bike-search-page-handler')
        ),
);
